import Api from '@/api/Api'
import Papa from 'papaparse'

//const DEV_STORY_SPREADSHEET = "2PACX-1vSIBx6d2BPehaqUs_3KIe8xll6q_bjAXr9HBaRdFEi2PRl-3YXLJJd_wKsJTEGHMFGubQQrmP4IrcJ3"
//const STORY_SPREADSHEET = "2PACX-1vTYbQdA87imaRvS3orlxbPcWS0eYItN3FcFS3tSzPisvKVKyc_AcC13p9mHS4rnAVoYsjueXUzjw8nz"

export default {
  async getStoryData () {
    //return Api().get( STORY_SPREADSHEET + '/pub?output=csv').then((results)=>{
    /*return Api().get('story.csv').then((results)=>{
      var csvData = results.data
      var jsonData = Papa.parse(csvData, {
        header : true
      })
      return jsonData
    })*/
    let res = []
    let response = await gapi.client.sheets.spreadsheets.values.get({
      spreadsheetId: '1z5254B0R0XTkbmvIyYDEhyRKRwIbP1pifJFqfB3Ms54',
      range: 'Final'
    })
    if(response.result.error){
      console.log('error')
    }
    var range = response.result;
    if (range.values.length > 0) {
      for (let i = 1; i < range.values.length; i++) {
        var row = range.values[i];
        let rowObj = {}
        range.values[0].forEach((field, index) => {
          rowObj[field] = row[index] || ''
        })
        res.push(rowObj)
      }
    } else {
      console.log('No data found.');
    }
    return res
  }
}



// WEBPACK FOOTER //
// ./src/api/StoryApi.js